import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";
class BonificacaoService {
    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.bonificacao}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.bonificacao.toLowerCase()}/edit`, data);
    }
}

export default new BonificacaoService();
